/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MessageRecipientType {
  GUESTS = 'guests',
  WAITLIST = 'waitlist',
}
